/** Builds the topic for each design 5.3 channel. One function per row; no string building. */
export const sseTopic = {
    build: (buildJobId) => `build:${buildJobId}`,
    voiceAgentLive: (voiceAgentId) => `voice_agent:${voiceAgentId}:live`,
    conversationTranscript: (conversationId) => `conversation:${conversationId}:transcript`,
    workspaceActivity: (workspaceId) => `workspace:${workspaceId}:activity`,
    shopCustomerOrder: (shopId) => `shop:${shopId}:order`,
    staffLive: () => "staff:live",
    staffCapacity: () => "staff:capacity",
};
/** The Redis channel a topic fans out on. The account id is structural, not advisory. */
export function sseChannel(account, topic) {
    return `sse:${account}:${topic}`;
}
export const SSE_EVENT_NAME = [
    "build.step",
    "build.check",
    "build.progress",
    "build.succeeded",
    "build.failed",
    "conversation.started",
    "conversation.updated",
    "conversation.ended",
    "channel_unit.changed",
    "turn.partial",
    "turn.final",
    "conversation.event",
    "conversation_flag.raised",
    "notification.created",
    "billing.alert",
    "snapshot",
    "customer_order",
    "shop_customer",
    "coupon",
    "capacity.snapshot",
    "gpu_pool.state",
    "gpu_replica.observed",
    "resync",
    // plan-005 OP-11 (design §18.14.3): appended last, never interleaved.
    "customer_order_payment",
    // plan-029 WAPP-HIST2 (design §40.19.5, ED-17): appended last, never interleaved.
    "confirmation_code_shown",
];
/** The bounded per-connection queue and heartbeat cadence of design 5.3. */
export const SSE_CONNECTION = {
    queueDepth: 256,
    heartbeatMs: 15_000,
};
//# sourceMappingURL=sse.js.map